/* eslint-disable quotes */

import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

/**
 * MiniGuidesService centraliza todas las llamadas relacionadas a Mini Guías.
 *
 * getAll --> Lista paginada/filtrada de mini guías
 * getById --> Detalle de una mini guía (opcionalmente por lang)
 * create --> Crea una mini guía
 * update --> Actualiza una mini guía
 * remove --> Elimina una mini guía
 *
 * getAgeGroups --> Obtiene grupos etarios disponibles (para select opción única)
 * getBiologicalSexes --> Obtiene sexos biológicos disponibles (para select opción única)
 * getHormonalImbalances --> Desbalances hormonales (multiopción)
 * getNutritionalDeficits --> Déficits nutricionales (multiopción)
 * getBadHabits --> Malos hábitos detectados (multiopción)
 * getStatuses --> Estados disponibles (opción única)
 */

const MiniGuidesService = {
  // ---- LISTADO / BÚSQUEDA ----
  getAll: async function (params = {}, lang) {
    const response = await ApiService._get("api/mini-guide", params, lang);
    return response.data;
  },

  // ---- DETALLE ----
  getById: async function (id, withTranslations = 0, lang = null) {
    const response = await ApiService.get(`api/mini-guide/${id}?withTranslations=${withTranslations}`, lang);
    return response.data;
  },

  // ---- CREAR / ACTUALIZAR / ELIMINAR ----
  create: async function (payload) {
    const response = await ApiService.post("api/mini-guide", payload);
    return response.data;
  },

  update: async function (id, payload) {
    const response = await ApiService.put(`api/mini-guide/${id}`, payload);
    return response.data;
  },

  remove: async function (id) {
    const response = await ApiService.delete(`api/mini-guide/${id}`);
    return response.data;
  },

  // ---- CATÁLOGOS / SELECTS ----
  getCategories: async function () {
    const response = await ApiService.get("api/mini-guide/category");
    return response.data;
  },

  getSubcategories: async function (id) {
    const response = await ApiService.get(`api/mini-guide/subcategory/category_id/${id}`);
    return response.data;
  },

  getAgeGroups: async function (params = {}) {
    const response = await ApiService.get("api/mini-guide/age-groups", params);
    return response.data;
  },

  getBiologicalSexes: async function (params = {}) {
    const response = await ApiService.get("api/mini-guide/biological-sexes", params);
    return response.data;
  },

  getHormonalImbalances: async function (params = {}) {
    const response = await ApiService.get("api/mini-guide/hormonal-imbalances", params);
    return response.data;
  },

  getNutritionalDeficits: async function () {
    const response = await ApiService.get("api/nutritional-deficit");
    return response.data;
  },

  getBadHabits: async function () {
    const response = await ApiService.get("api/habit/bad-habit");
    return response.data;
  },

  getStatuses: async function (params = {}) {
    const response = await ApiService.get("api/mini-guide/status", params);
    return response.data;
  },

  getForbiddenTerms: async function () {
    const response = await ApiService.get("api/forbidden-term");
    return response.data;
  },
};

export default MiniGuidesService;
